// src/components/Spinner.js
import React from 'react';

// You can add the CSS for this directly in your App.css file
export const Spinner = () => <div className="spinner"></div>;